import { convertPosToRange } from './common';
import _ from 'lodash';

// *** TODO ***
// Créer deux classes MetadataCollection et Metadata
// L'objet MetadatCollection va contenir un tableua d'objet Metadata
//
// export default class MetadataCollection {
//   constructor(d) {
//     this.data = d.map(m => new Metadata(m));
//   }
// }
// export default class Metadata {
//   constructor(d) {
//     this.data = d;
//   }

//   isFromType(typearray) {
//     return this.data.hasOwnProperty('trackType') && typearray.includes(this.data.trackType);
//   }
// }

// Metadata Collection
export default class SeqMetadata {
  constructor(d) {
    this.data = d;
  }

  getAll() {
    return this.data;
  }
  /**
   * Return an array of metadata composed of metadata whose type is include in the array 't'
   * @param {*} t Array of trackType
   * TODO: retourner un tableau d'objet MetadataCollection
   */
  getMetadataByType(t) {
    return this.data.filter(m => m.hasOwnProperty('trackType') && t.includes(m.trackType));
  }

  /**
   * Return an array of the metadata of the sequence whose id == 'id'
   * TODO: retourner un tableau d'objet MetadataCollection
   * @param {String} id
   */
  getMetadataFromId(id) {
    let copy = JSON.parse(JSON.stringify(this.data));
    let newData = copy
      .map(m => {
        let m2 = Object.assign({}, m);
        m2.categories = m2.categories
          .map(function(c) {
            c.regions = c.regions.filter(r => {
              return r.id === id;
            });
            return c;
          })
          .filter(c => c.regions.length > 0);
        return m2;
      })
      .filter(m => m.categories.length > 0);
    return newData;
  }

  /**
   * Build an array of metadata for the target sequences
   *
   * @param {*} metadataarray Array of metadata of the source
   * @param {*} source sequence object which has an attribute 'seq'
   * @param {*} targets array of sequences objects which have an attribute 'seq'
   * TODO: pour le moment, ce n'est pas vraiment une fonction de la classe SeqMetadata car metadatatarray est passé en parametre
   * Quand les fonctions getMetadataFromId et getMetadataByType retourneront une object MetadataCollection,
   * le parametre metadatatarray ne sera plus nécessaire
   */
  extractMetadata(metadataarray, source, targets) {
    // sequence of the source
    const sourcesequence = source.seq.split('');

    let newmetadataarray = [];

    metadataarray.forEach(m => {
      let newM = { categories: [], label: m.label };
      if (m.hasOwnProperty('trackType')) newM.trackType = m.trackType;

      m.categories.forEach(c => {
        let newC = { regions: [], label: c.label };
        if (c.hasOwnProperty('style')) newC.style = _.cloneDeep(c.style);

        c.regions.forEach(r => {
          if (r.hasOwnProperty('ranges')) {
            targets.forEach(t => {
              const targetsequence = t.seq.split('');
              // list all the positions where source and target are identical
              let conservedPos = [];
              r.ranges.forEach(pos => {
                for (let p = pos[0]; p <= pos[1]; p++) {
                  if (targetsequence[p - 1] === sourcesequence[p - 1]) conservedPos.push(p);
                }
              });
              const newRanges = convertPosToRange(conservedPos);

              if (newRanges.length > 0) {
                newC.regions.push({
                  id: t.id,
                  ranges: newRanges,
                });
              }
            });
          }
        });
        if (newC.regions.length > 0) newM.categories.push(newC);
      });

      if (newM.categories.length > 0) newmetadataarray.push(newM);
    });

    return newmetadataarray;
  }

  formattedAsGlyph() {
    let g = _.cloneDeep(this.data);
    g.forEach(e => e.categories.forEach(c => (c.ids = c.regions.map(r => r.id).flat())));
    return g;
  }

  /**
   * Extract the metadata of the types included in trackTypes array and transform in Track object
   * @param {Array} trackTypes
   * @param {Array} categoryList
   */
  getTracks(trackTypes, categoryList = []) {
    // extract the metadata of the trackTypes "trackTypes"
    let metadataGenericPositions = this.getMetadataByType(trackTypes);
    if (metadataGenericPositions.length <= 0) {
      return [];
    }
    let tracks = [];
    metadataGenericPositions.forEach(m => {
      let track = {
        trackLabel: m.label,
        features: [],
      };
      m.categories.forEach(c => {
        if (categoryList.length == 0 || categoryList.includes(c.label)) {
          c.regions.forEach(r =>
            track.features.push({ positions: r.ranges, type: '', color: c.style.fill })
          );
        }
      });
      tracks.push(track);
    });

    return tracks;
  }

  /**
   * Filter the metadataarray by categories
   * @param {Array} metadataArray
   * @param {Array} categoryLabels
   * TODO: filterByCategory is not a function of a SeqMetadata object
   * => Peut etre a sortir de cet objet
   */
  filterByCategory(metadataArray, categoryLabels) {
    return metadataArray
      .map(m => {
        m.categories = m.categories.filter(c => categoryLabels.includes(c.label));
        return m;
      })
      .filter(m => m.categories.length > 0);
  }

  /**
   * Display all the metadata
   * Only used to debug
   * @param {*} meta
   */
  printMetadata(meta) {
    console.log('DISPLAY METADATA');
    meta.forEach(m => {
      console.log('metadata : ' + m.label);
      m.categories.forEach(c => {
        console.log('-conservation categorie ' + c.label);
        console.log(c.regions.length);
        c.regions.forEach(r => console.log(r.ranges));
      });
    });
  }
}
